import Canvas from './canvas'
import _ from 'lodash'
import $ from 'jquery'

/*
 * ScalableCanvas is a version of the canvas, that resizes itself
 * when it's rendered, so it fits within the outer container.
 */
var ScalableCanvas = Canvas.extend({

  className: 'scalable-canvas',

  readonly: true, // Wobs on a scalable canvas are readonly

  initialize: function () {
    Canvas.prototype.initialize.apply(this, arguments)

    _.bindAll(this, 'resize')

    $(window).on('resize', this.resize)
    this.listenTo(this.collection, 'change', this.resize)
  },

  reset: function () {
    Canvas.prototype.reset.apply(this, arguments)
    this.resize()
  },

  dimensions: function () {
    var bb = this.boundingBox()
      , width = bb.maxX
      , height = bb.maxY
      , parent = this.getParent()

    return {
      width: width,
      height: height,
      contentWidth: width + (2 * this.padding),
      contentHeight: height + (2 * this.padding),
      actualParentWidth: parent.width(),
      actualParentHeight: parent.height(),
    }
  },

  sizeStyles: function () {
    var dim = this.dimensions()
      , scale = dim.actualParentWidth / this.el.scrollWidth
      , bottom = (dim.contentHeight * scale) - dim.contentHeight
      , styles = {
        'transform': 'scale(' + scale + ')',
        'padding-bottom': this.padding + 'px',
        'padding-top': this.padding + 'px',
        'padding-left': this.padding + 'px',
        'padding-right': this.padding + 'px',
        'margin-top': '0px',
        'margin-left': '0px',
        'margin-right': '0px'
      }

    if (bottom > 0) {
      styles['padding-bottom'] = bottom + this.padding + 'px'
    } else {
      styles['margin-bottom'] = bottom + 'px'
    }

    return styles
  },

  /*
   * A scalable canvas may need to be scaled down if wobs are outside of the viewport.
   * This does that.
   */
  resize: function () {
    Canvas.prototype.resize.apply(this, null) // Set the real width/height

    // Show the empty canvas if they don't have wobs
    this.$el.toggleClass('empty-canvas', this.collection.size() === 0)
            .css(this.sizeStyles())

    return this
  },

  release: function () {
    Canvas.prototype.release.apply(this, arguments)
    $(window).off('resize', this.resize)
  }

})

export default ScalableCanvas
